import { render, staticRenderFns } from "./sharing-content.vue?vue&type=template&id=644ecb23&"
import script from "./sharing-content.vue?vue&type=script&lang=ts&"
export * from "./sharing-content.vue?vue&type=script&lang=ts&"
import style0 from "./sharing-content.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports